import React from 'react';
import { Button, Divider, SparkIcon, SparkModalPortal, TagFeedback, Text } from '@spark';
import { noticeLine, whatsNewItems } from '../utils/whatsNew';

/**
 * What's new after an update (Figma 91:12570): every highlight of the releases
 * the user has not seen, each with its area's icon. It stays open until the
 * user closes it with × or Start exploring; the overlay and Escape do not close it.
 */
export default function WhatsNewModal({ open, releases, onClose }) {
    const items = whatsNewItems(releases);
    const notesUrl = releases.find((release) => release.changelog_url)?.changelog_url;

    return (
        <SparkModalPortal open={open} onClose={onClose} width={560} maskClosable={false} keyboard={false}>
            <section className="platform-upgrader-whats-new" aria-labelledby="platform-upgrader-whats-new-title">
                <Button
                    variant="ghost"
                    size="small"
                    type="button"
                    aria-label="Close"
                    className="platform-upgrader-whats-new-close"
                    icon={<SparkIcon slug="close" size={20} />}
                    onClick={onClose}
                />
                <div className="platform-upgrader-whats-new-body">
                    <div className="platform-upgrader-whats-new-header">
                        <TagFeedback label="Update complete" variant="success" showIcon />
                        <div className="platform-upgrader-whats-new-title">
                            <Text as="h2" id="platform-upgrader-whats-new-title" variant="heading-4-semibold" color="primary">
                                What’s new
                            </Text>
                            <Text as="p" variant="base-regular" color="secondary">
                                {noticeLine(items.length)}
                            </Text>
                        </div>
                    </div>
                    {items.length > 0 && (
                        <ul className="platform-upgrader-whats-new-list">
                            {items.map((item) => (
                                <li key={item.key} className="platform-upgrader-whats-new-item">
                                    <span className="platform-upgrader-whats-new-tile" aria-hidden="true">
                                        <SparkIcon slug={item.icon} size="medium" />
                                    </span>
                                    <div className="platform-upgrader-whats-new-text">
                                        <Text as="p" variant="lead-medium" color="primary">
                                            {item.title}
                                        </Text>
                                        {item.description && (
                                            <Text as="p" variant="base-regular" color="secondary">
                                                {item.description}
                                            </Text>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <Divider />
                <div className="platform-upgrader-whats-new-footer">
                    {notesUrl && (
                        <Button
                            variant="ghost"
                            size="medium"
                            type="button"
                            onClick={() => window.open(notesUrl, '_blank', 'noopener,noreferrer')}
                        >
                            Release notes
                        </Button>
                    )}
                    <Button variant="primary" size="medium" type="button" onClick={onClose}>
                        Start exploring
                    </Button>
                </div>
            </section>
        </SparkModalPortal>
    );
}
